import type { UserMembership, UserWithMemberships } from '../../../api/users';

export function getUserDisplayName(user: UserWithMemberships): string {
  if (user.firstName && user.lastName) {
    return `${user.firstName} ${user.lastName}`;
  }
  return user.email;
}

export function getUserInitials(user: UserWithMemberships): string {
  const name = getUserDisplayName(user);
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return `${parts[0]![0] ?? ''}${parts[1]![0] ?? ''}`.toUpperCase();
}

export function getMembershipRoleLabel(role: UserMembership['role']): string {
  return role === 'MANAGER' ? 'Gestor' : 'Usuário';
}

export function getMembershipStatusLabel(status: UserMembership['status']): string {
  switch (status) {
    case 'ACTIVE':
      return 'Ativo';
    case 'INVITED':
      return 'Convidado';
    case 'SUSPENDED':
      return 'Suspenso';
    default:
      return status;
  }
}

export function getMembershipRoleChipColor(
  role: UserMembership['role'],
): 'accent' | 'default' {
  return role === 'MANAGER' ? 'accent' : 'default';
}

export function getMembershipStatusChipColor(
  status: UserMembership['status'],
): 'success' | 'warning' | 'danger' | 'default' {
  switch (status) {
    case 'ACTIVE':
      return 'success';
    case 'INVITED':
      return 'warning';
    case 'SUSPENDED':
      return 'danger';
    default:
      return 'default';
  }
}

export function matchesUserSearch(user: UserWithMemberships, search: string): boolean {
  const term = search.trim().toLowerCase();
  if (!term) return true;

  return (
    user.email.toLowerCase().includes(term) ||
    (user.firstName?.toLowerCase().includes(term) ?? false) ||
    (user.lastName?.toLowerCase().includes(term) ?? false) ||
    (user.documentNumber?.includes(search.trim()) ?? false)
  );
}
